import { generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/vendors';
import { callApiV3Get} from 'utilities/apiCaller';
import API from 'constants/api';
import { TransportMode } from 'constants/modes';

export const fetchVendors = (country:string, companyCode: string, purchase: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_VENDORS.PENDING });
        try {
            const res = await callApiV3Get(API.Vendors.GetVendors, { 'country': country, 'companyCode': companyCode, 'purchaseOrg': purchase }, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.FETCH_VENDORS.FULFILLED, vendors: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_VENDORS.REJECTED, errors });
        }
    }
};